import type { JwtType } from "./types";
export const setJwt = (jwt: JwtType) => sessionStorage.setItem("jwt", JSON.stringify(jwt));

export const getJwt = (): JwtType => {
  try {
    return JSON.parse(sessionStorage.getItem("jwt") || "{}");
  } catch (_) {
    return {
      token: null
    };
  }
};

export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift();
  return null;
};
